import { Box, Typography } from '@material-ui/core'
import moment from 'moment-timezone'
import useStyles from '../styles/styles'
import ApartmentIcon from '@mui/icons-material/Apartment'
import { TIMEZONE } from '../../config'

const Title = ({ record, details }) => {
  const date = moment.utc(details?.date).tz(TIMEZONE).format('LLL')
  const classes = useStyles()
  return (
    <Box>
      <Typography variant="h5">
        <b>
          Ordre du jour de l'assemblée générale{' '}
          {record.estordinaire ? 'ordinaire' : 'extraordinaire'} du{' '}
          {moment.utc(details.date).tz(TIMEZONE).format('DD MMMM YYYY')}
        </b>
      </Typography>
      <Typography variant="subtitle2" color="black">
        {record.ag_libelle}
      </Typography>
      <Typography variant="subtitle2" color="black" gutterBottom>
        <b>Date de l'AG : {date}</b>
        <br />
        <b>Lieu : {record.lieu}</b>
      </Typography>
      <div className={classes.apartmentInfoWrapper}>
        <ApartmentIcon className={classes.apartmentIcon} />
        <Typography variant="subtitle2">
          <b>Immeuble</b>
          <br />
          {record.libelle}
          <br />
          {record.adresse} {record.codepostal} {record.ville}
        </Typography>
      </div>
      <br />
      <Typography variant="body2">
        Cette Assemblée sera appelée à délibérer exclusivement sur l'ordre du
        jour suivant :
      </Typography>
    </Box>
  )
}
export default Title
